// const checkurl=[
//     'https://me-zil-digital-beapp-dev.azurewebsites.net',
//     'https://me-zil-digital-beapp-sat.azurewebsites.net','https://me-zil-da-plt-beapp-prod.azurewebsites.net'
// ];


const checkurl = [
    process.env.REACT_APP_API_ENDPOINT
];

export function validateenvurl(url) 
 {
    let parsed;
    try{
    parsed =new URL(url);
   }catch{
        throw new Error('Invalid URL format');
   }
 
    if(checkurl?.includes(parsed.hostname))
        {
        throw new Error('invalid api host')    
        }
    if(parsed.protocol !== 'https:')
        {
    throw new Error('only http allowed')
        }
    return parsed.toString();
}



